import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './ErrorBoundary';
import { useDialogueStore } from '@/state/dialogueStore';
import { useGameStore } from '@/state/gameStore';
import '@/styles/tokens.css';
import '@/styles/fonts.css';
import '@/styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root missing from index.html');

if (import.meta.env.DEV) {
  window.gameStore = useGameStore;
  window.dialogueStore = useDialogueStore;
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
